/* eslint-disable import/prefer-default-export */
import Cookies from "js-cookie";

export const SESSION_ACTIVE_COOKIE_NAME = "tc_session_active";

/**
 * @return {Boolean}
 */
export function isSessionActive() {
  return Cookies.get(SESSION_ACTIVE_COOKIE_NAME) === "true";
}
